import { Row } from "antd";
import { uniqueMergeArrays } from "functions/arrays";
import React from "react";
import { useSelector } from "react-redux";
import { useFirestoreConnect } from "react-redux-firebase";
import { FIRESTORE_PROMOTIONS_TABLE } from "../../../../constants/FirestoreConstant";
import AddDiscount from "./AddDiscount";
import DiscountList from "./DiscountList";

const Promotions = () => {
  // Deze pagina leest de collectie, dus abonneert de pagina zelf. Stond tot nu
  // toe in layouts/app-layout (op elke CMS-pagina) -- zie docs/cms-performance.md.
  useFirestoreConnect([{ collection: FIRESTORE_PROMOTIONS_TABLE }]);
  const products = useSelector((state) => state.firestoreReducer.ordered.products);
  const categories = uniqueMergeArrays(products, "category");
  return (
    <Row gutter={16}>
      <AddDiscount products={products} categories={categories}/>
      <DiscountList products={products} categories={categories}/>
    </Row>
  );
};

export default Promotions;
